export default "__VITE_ASSET__UybVkhQw__"